import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ApprovalProvider } from '../partner/internalRequestReceive/ContextAPI';
import Index from '../partner/internalRequestReceive/Index';
import PermissionDenied from './PermissionDenied';

export default function PartnerInternalRequestReceive() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['partner-internal-request-receive']) return <PermissionDenied />;

    return (
        <ApprovalProvider>
            <Index />
        </ApprovalProvider>
    );
}
